<template>
  <div class="layout">
    <div class="body">
      <router-view v-slot="{Component}">
        <component :is="Component" :key="route.fullPath"/>
      </router-view >
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script setup>
import { useRoute, useRouter } from 'vue-router'
import { ref, watch } from 'vue'
import pageFooter from '@/components/pageFooter'

const hiddenFooter = ref(false)

const route = useRoute()

watch(() => route.path,
  (newPath, oldPath) => {
    console.log(route.meta, 'routeroute')


  },
  { immediate: true }
);

</script>
<style lang="less" scoped>
.page-body {
  // display: flex;
  // overflow: hidden;
  position: relative;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.body {
  margin: 0 auto;
}

.page-footer-main {
  margin: 0 auto;
  text-align: left;
  display: flex;
  // align-items: center;
  justify-content: space-around;
  width: 1200px;
}


</style>
